<template>
  <div class="dialog-pro-add">
    <el-dialog class="dialog-pro m-common-pro-dialog" title="新建项目" :show-close="false" :visible.sync="dialogVisible"
      :width="'900px'">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item class="mb-30" prop="projectName">
          <el-input v-model="form.projectName" placeholder="项目名称" />
        </el-form-item>

        <el-form-item class="mb-30" prop="planPeriod">
          <el-input v-model="form.planPeriod" placeholder="项目周期" />
        </el-form-item>

        <el-form-item class="mb-30" prop="planTime">
          <el-date-picker class="w-100" v-model="form.planTime" value-format="yyyy-MM-dd" type="date"
            placeholder="项目开始时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="mb-20" prop="projectType">
          <el-select v-model="form.projectType" placeholder="项目类型" style="display:block;">
            <el-option v-for="item in projectTypeList" :key="item.dictCode" :label="item.dictName"
              :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="mb-30" prop="planPlace">
          <el-input type="textarea" v-model="form.ext1" placeholder="项目简介" />
        </el-form-item>

        <el-form-item class="mb-30" prop="planPlace">
          <el-input v-model="form.planPlace" placeholder="项目地点" />
        </el-form-item>

        <el-form-item class="mb-20" prop="planDept">
          <el-select v-model="form.planDept" placeholder="项目部门" style="display:block;">
            <el-option v-for="item in department" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="mb-20" prop="charge">
          <el-select v-model="form.charge" filterable placeholder="负责人" style="display:block;">
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="mb-20" prop="charge">
          <el-select v-model="form.charge1" filterable multiple placeholder="参与人" style="display:block;">
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer tr mt-30">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit('form')" :loading="loadingSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        projectName: '',
        planPeriod: '',
        planTime: '',
        planPlace: '',
        planDept: '',
        charge: this.$store.state.user.userid,
        projectType: '',

      },
      pageType: '',
      detailId: '',
      department: [],
      userList: [],
      projectTypeList: [],
      loadingSave: false,
      rules: {
        projectName: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        planPeriod: [{ required: true, message: '项目周期不能为空', trigger: 'blur' }],
        planTime: [{ required: true, message: '计划开展时间不能为空', trigger: 'blur' }],
      }
    }
  },
  methods: {
    init(type, detailId) {
      this.pageType = type // add 新增 edit 编辑 
      this.detailId = detailId || ''
      this.dialogVisible = true
      this.getProjectTypeList()
      this.getDropdownValue()
    },
    // 获取项目类型列表
    getProjectTypeList() {
      this.$http.get('/job/employeeDict').then(res => {
        if (res.success) {
          const { department, user } = res.result
          this.department = department
          this.userList = user
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['project_type']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            this.projectTypeList = state['project_type']
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 新建项目
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loadingSave = true
          this.form.ext2 = '1'
          this.$http.post('/project/addProject', {
            ...this.form, //	项目名称
          }).then(res => {
            this.loadingSave = false
            if (res.success) {
              this.$parent.getData()
              this.$message.success('项目创建成功')
              this.onCancel()
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            this.loadingSave = false
          })
        } else {
          return false
        }
      })
    },
    onCancel() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },

  }
}
</script>

<style lang="scss" scoped>
.dialog-pro {
  /deep/ .el-dialog {
    padding-right: 20px;
    .el-date-editor {
      width: 100%;
    }
  }
  .dialog-pro-wrap {
    padding-right: 10px;
    max-height: 700px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .el-card.is-always-shadow {
    // box-shadow: none;
    box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
    border-radius: 4px;
  }
  .el-card {
    border: 1px solid transparent;
    background: transparent;
    &.active {
      border: 1px solid rgba(5, 144, 255, 1);
    }
  }
  .box {
    margin-bottom: 30px;
    cursor: pointer;
  }
}
</style>


